import {useEffect} from 'react'
import useCurrentUser from '../../hooks/useCurrentUser'
import {useHistory} from 'react-router-dom'

const PWAStart = ()=>{
	const user = useCurrentUser()
	const history = useHistory()
	switch(user.account_type){
		case "trainer":
			history.replace('/trainer')
		break
		case "client":
			history.replace('/client_dashboard')
		break
		case "gym":
			history.replace('/gym')
		break
		case "chain":
			history.replace('/chain')
		break
	}
	return (
		<div/>
	)
}

export default PWAStart